import styled from 'styled-components';
import { AvatarBadgeMixin } from '../../mixins/components/AvatarBadgeMixin';
export var StyledAvatarBadge = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAvatarBadge",
  componentId: "c11n-8-111-1__sc-1j91ypt-0"
})(["", ""], AvatarBadgeMixin);